import { type MenuLink } from "core-fe-lib/components-shadcn/types/menu-link";
import { Role } from "core-fe-lib/openapi/core/models/Role";

export function getPipelineLinks(t: any): MenuLink[] {
  return [
    {
      title: t("layout.navigation.pipeline.title"),
      caption: t("layout.navigation.pipeline.caption"),
      icon: "account_tree",
      hasExpansion: true,
      items: [
        {
          title: t("layout.navigation.pipeline.runs.title"),
          caption: t("layout.navigation.pipeline.runs.caption"),
          icon: "play_circle",
          link: "/pipeline/runs",
          requiredPrivilege: Role.ADMIN,
        },
        {
          title: t("layout.navigation.pipeline.llmPricing.title"),
          caption: t("layout.navigation.pipeline.llmPricing.caption"),
          icon: "price_change",
          link: "/pipeline/llm-pricing",
          requiredPrivilege: Role.ADMIN,
        },
        {
          title: t("layout.navigation.pipeline.cost.title"),
          caption: t("layout.navigation.pipeline.cost.caption"),
          icon: "monitoring",
          link: "/pipeline/cost",
          requiredPrivilege: Role.ADMIN,
        },
        {
          title: t("layout.navigation.seed.title"),
          caption: t("layout.navigation.seed.caption"),
          icon: "output",
          link: "/pipeline/seed",
          requiredPrivilege: Role.ADMIN,
        },
      ],
    },
  ];
}
